import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

const ls = (sel, dat) =>
  dat
    ? localStorage.setItem(sel, JSON.stringify(dat))
    : JSON.parse(localStorage.getItem(sel))

const default_state = {
  date: undefined,
  daytime: undefined,
  termtype: undefined,
  gender: undefined,
  firstname: undefined,
  lastname: undefined,
  email: undefined,
  tel: undefined,
  pendingAuth: false,
  retries: 1,
}

const static_state = {
  version: "1.2.20",
  months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split(
    "_"
  ),
  daytimes_short: ["vormittags", "nachmittags", "abends"],
  termintypes: [
    {
      name: "Fitness-Beratung",
      desc:
        "Du interessierst dich für uns: Fitness, Kurse, Sauna, Rehasport oder Figur? Lass dich individuell beraten – kostenlos und unverbindlich  informieren. Wir schauen gemeinsam, was das Richtige für dich ist. ",
    },
    {
      name: "Kurs-Beratung",
      desc:
        "Du interessierst dich speziell für unser umfangreiches Kursangebot: Gymnastik-, Tanz-, Fitness-, Figur-, Rehasport? Lass dich individuell beraten – kostenlos und unverbindlich  informieren. Wir schauen gemeinsam, was das Richtige für dich ist.",
    },
    {
      name: "Rehasport-Beratung",
      desc:
        "Du hast eine Rehasportverordnung von deinem Arzt und interessierst dich für deine Möglichkeiten bei uns? Lass dich individuell beraten – kostenlos und unverbindlich  informieren. Wir schauen gemeinsam, was das Richtige für dich ist.",
    },
    {
      name: "Figur-Beratung",
      desc:
        "Du interessierst dich speziell für unser Figurangebote: Abnehmen, Figurtraining, HypoxiTrainer, PowerPlate, Ernährungsberatung? Lass dich individuell beraten – kostenlos und unverbindlich  informieren. Wir schauen gemeinsam, was das Richtige für dich ist.",
    },
    {
      name: "Sauna Besuch",
      desc:
        "Du möchtest gern in unsere wunderschönen Saunen gehen? Schau dir hier die aktuellen Saunazeiten an. Tageskarte, DauerAbo - zu den unterschiedlichen Möglichkeiten beraten wir dich gern.",
    },
  ],
}

const state = ls("state")
  ? Object.assign({}, default_state, ls("state"), static_state)
  : Object.assign({}, default_state, static_state)

if (ls("lastVersion") !== null && ls("lastVersion") !== static_state.version) {
  localStorage.clear()
  console.log("cleared localStorage because of an outdated version")
  location.reload()
}
ls("lastVersion", static_state.version)

export default new Vuex.Store({
  state,
  mutations: {
    setData(_state, data) {
      Object.keys(data).forEach(key => {
        _state[key] = data[key]
      })
      ls("state", _state)
    },
  },
  actions: {},
  modules: {},
})
